// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/global.scss';
import '@assets/Scss/page.scss';

// Import favicons
import '@icon/favicon.png?url';
import '@icon/favicon.svg?url';
import '@icon/favicon-touch.png?url';
import '@icon/favicon-twtdh.png?url';
import '@icon/favicon-twtdh.svg?url';
import '@icon/favicon-touch-twtdh.png?url';

// Import all svg files from the asset/Image/Icon directory automatically
Object.values(import.meta.glob('@icon/*.svg', { eager: true, query: '?url', import: 'default' }));

// Open CCM19 widget on links with class `.ccm19-change-settings`
document.querySelectorAll('a[href="#ccm19-change-settings"]').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    CCM?.openWidget?.();
  });
});
